import type { TicketFieldSchema } from "@/api/useJira.types"
import type { TicketFieldControl, TicketFieldMode } from "./TicketField.types"

const hasAllowedValues = (field: TicketFieldSchema) =>
  !!field.allowedValues?.length

// Fields without a fixed list of values are searched through the vendor
const isRemote = (field: TicketFieldSchema) =>
  !!field.autocomplete || !hasAllowedValues(field)

export const getTicketFieldControl = (
  field: TicketFieldSchema,
  mode: TicketFieldMode
): TicketFieldControl => {
  const isTemplate = mode === "template"

  switch (field.type) {
    case "date":
      return isTemplate ? "onDemandDate" : "date"
    case "sprint":
      if (isTemplate) return "onDemandSprint"
      return isRemote(field) ? "remoteSelect" : "select"
    case "user":
    case "option":
      return isRemote(field) ? "remoteSelect" : "select"
    case "multi_option":
      return isRemote(field) ? "remoteMultiSelect" : "multiSelect"
    case "number":
      return "number"
    case "text":
      return "textArea"
    default:
      return isTemplate ? "templateInput" : "input"
  }
}
